package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.queryParamValues
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `GET /api/v1/industries`: the industries having data for the added occupations (all occupations when none are added).
 *
 * The year bounds are optional, as the API treats them: without them the API covers the same latest five years as
 * `GET /api/v1/chart` without them, so the industries listed are the ones the chart has data for.
 */
class WMIndustriesWithDataRequestBuilder: WMOccupationsAndYearBoundRequestBuilder<WMIndustriesWithDataRequestBuilder>(yearBoundsRequired = false) {

    override fun build(): FSRequest<Nothing> {
        replacePathParams("api", "v1", "industries")
        acceptJson()
        method(FSRequest.Method.Get)
        return super.build()
    }

    override fun self(): WMIndustriesWithDataRequestBuilder = this
}
